export const LISTE_COMMENTAIRE = {
  title: 'Liste des commentaires pré-paramétrés',
  tab: {
    commentaire: 'Commentaire',
    libelle: 'Libellé',
  },
  actions: {
    add: 'Ajouter un commentaire pré-paramétré',
    search: 'Rechercher',
  },
};

export const AJOUT_MODIFICATION_COMMENTAIRE = {
  title: {
    add: 'Ajouter un commentaire pré-paramétré',
    edit: 'Modifier un commentaire pré-paramétré',
  },
  success: {
    add: 'Commentaire ajouté avec succès',
    edit: 'Commentaire modifié avec succès',
  },
  error: {
    problemOccurred: 'Un problème est survenu',
    libelle: 'Commentaire',
    message: 'Description',
  },
  commentaire: 'Commentaire',
  description: 'Description',
  actions: {
    cancel: 'Annuler',
  },
};

export const COMMENTAIRE = {
  title: 'Commentaires',
  ligneVente: {
    commentaire: 'Commentaire',
    libelle: 'Libellé',
  },
  actions: {
    search: 'Recherche...',
    add: '+ Créer un commentaire',
    noResult: 'Aucun résultat',
  },
};
